import { boolean } from "mathjs";

export function selectInput(input:HTMLInputElement, blockScroll:boolean = false) {
  if (!input || input.disabled) {
    return;
  }

  if (!input.focus) return;
  (input as HTMLElement).focus({ preventScroll: blockScroll });

  //setCaretPosition(input, input.value?.length ?? 0);

  if (!input.select) return;
  input.select();
  input.scrollLeft = 0; 
}

export function focusNextTabable(current: HTMLInputElement | HTMLElement, getNextElement?: boolean, setFocusFirstEleWhenNextNull?: boolean) {
  const tabableElements = getAllTabableElements();
  let currentInTabOrderFound = false
  let nextTabElement: Element | null = null;
  tabableElements.forEach(x => {
    if (x === current) {
      currentInTabOrderFound = true;
      return;
    }
    if (currentInTabOrderFound && !nextTabElement) {
      if ((x as any).disabled === true) {
        return;
      }

      nextTabElement = x;
    }
  });

  if (nextTabElement) {
    const tempNextTabElement = nextTabElement as HTMLElement;
    if (tempNextTabElement) {
      if (getNextElement)
        return getTabableElementByIndex(Array.from(tabableElements).indexOf(tempNextTabElement));

      //tempNextTabElement.focus();
      if (tempNextTabElement instanceof HTMLInputElement)
        selectInput(tempNextTabElement)
      else if (tempNextTabElement instanceof HTMLElement)
        tempNextTabElement?.focus();
    }
  }
  else{
    if(setFocusFirstEleWhenNextNull) focusTabableByIndex(0);
  }
}

export function getCurrentTabableIndex(current: Element | null): number {
  let index = -1;

  if (current) {
    const tabableElements = Array.from(getAllTabableElements());
    index = tabableElements.indexOf(current);
  }

  return index;
}

export function focusTabableByIndex(activeIndex: number) {
  if (activeIndex >= 0) {
    const tabableElements = getAllTabableElements();
    const element = tabableElements.item(activeIndex);
    if (element) {
      if (element instanceof HTMLInputElement)
        selectInput(element);
      else if (element instanceof HTMLElement)
        element?.focus();
    }
  }
}

export function focusLastTabable() {
  const tabableElements = getAllTabableElements();;
  (tabableElements.item(tabableElements.length - 1) as HTMLElement)?.focus()
}

export function focusTabableBeforeAddLineBtn(focusedAddLineBtn: Element) {
  const index = getCurrentTabableIndex(focusedAddLineBtn);
  if (index !== 0)
    (getAllTabableElements().item(index - 1) as HTMLElement)?.focus()
  else
    focusLastTabable();
}

export function isFocusedLastTabable() {
  const tabableElements = getAllTabableElements();
  return (tabableElements.item(tabableElements.length - 1) as HTMLElement) === document.activeElement;
}

export function getAllTabableElements(){
  //"ifms-tabable-active"가 포함되면 전부 return하던 것을 OEH > AES Filling(Portal) 같은 곳에선 상단 tab btn에도 focus가 가능해 문제가 발생해 상단 tab button은 제외하고 return하도록 수정
  //return document.querySelectorAll('.ifms-tabable-active');
  return document.querySelectorAll('.ifms-tabable-active:not(.ifms-button-tabs)');
}

export function getTabableElementByIndex(index: number) {
  const tabableElements = getAllTabableElements();
  return (tabableElements.item(index) as HTMLElement);
}
